import { render, staticRenderFns } from "./CustomUserGroup.vue?vue&type=template&id=1129b672&scoped=true"
import script from "./CustomUserGroup.vue?vue&type=script&lang=js"
export * from "./CustomUserGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomUserGroup.vue?vue&type=style&index=0&id=1129b672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129b672",
  null
  
)

export default component.exports